import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { getEnumValue } from './get-enum-value'
import { ChannelSubSection } from '@api/common'

export const getChannelName = clientType => {
  return clientType === getEnumValue(VIPClientType.Internal)
    ? ChannelSubSection.Retail
    : ChannelSubSection.Wholesale
}

export const getTitleCaseChannelName = clientType => {
  let temp = getChannelName(clientType)
  return temp.charAt(0).toUpperCase() + temp.substring(1)
}

export const isRetailClient = clientType => {
  return getEnumValue(VIPClientType.Internal) === clientType
}
